var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBonusGameEmptySlotAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5914_7879)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.15664 3.41379C2.38107 6.17096 0.729614 12.1887 3.41565 16.8411C6.10168 21.4934 12.139 23.0721 16.9145 20.3149C20.873 18.0295 22.6885 13.4968 21.6582 9.36482C21.5232 8.8234 21.8527 8.27504 22.3941 8.14004C22.9355 8.00504 23.4839 8.33451 23.6189 8.87594C24.8667 13.8803 22.6662 19.3275 17.9249 22.0649C12.2126 25.3629 4.92677 23.4998 1.66566 17.8514C-1.59544 12.203 0.43405 4.96176 6.14628 1.6638C10.91 -1.08652 16.7604 -0.247938 20.4679 3.37821C20.8668 3.76838 20.8739 4.40806 20.4837 4.80698C20.0935 5.20589 19.4538 5.21299 19.0549 4.82282C15.9941 1.8291 11.1339 1.11749 7.15664 3.41379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6463 20.0973C18.5918 19.0076 18.2712 17.9479 17.7124 17.0108C17.1537 16.0737 16.3738 15.2878 15.441 14.7218C16.3452 14.0036 17.0035 13.0218 17.3248 11.9127C17.646 10.8035 17.6143 9.62192 17.234 8.53162C16.8536 7.44132 16.1435 6.49635 15.2021 5.82769C14.2606 5.15903 13.1345 4.7998 11.9798 4.7998C10.825 4.7998 9.69889 5.15903 8.75745 5.82769C7.81601 6.49635 7.10591 7.44132 6.72556 8.53162C6.34521 9.62192 6.31347 10.8035 6.63472 11.9127C6.95598 13.0218 7.61432 14.0036 8.5185 14.7218C7.5831 15.2841 6.79979 16.0671 6.23712 17.0023C5.67446 17.9375 5.34959 18.9964 5.29096 20.0862C5.21099 20.5123 5.5442 21.4116 7.51685 21.5998V21.5887V21.533V20.4201C7.51685 19.2394 7.98587 18.1071 8.82074 17.2722C9.65561 16.4373 10.7879 15.9683 11.9686 15.9683C13.1493 15.9683 14.2816 16.4373 15.1165 17.2722C15.9514 18.1071 16.4204 19.2394 16.4204 20.4201V21.533V21.5998C18.3384 21.4116 18.7035 20.5197 18.6463 20.0973ZM12.0338 14.0652C14.0936 14.0652 15.7634 12.3954 15.7634 10.3356C15.7634 8.27583 14.0936 6.60605 12.0338 6.60605C9.97403 6.60605 8.30424 8.27583 8.30424 10.3356C8.30424 12.3954 9.97403 14.0652 12.0338 14.0652Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5914_7879"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBonusGameEmptySlotAvatar);
export default __webpack_public_path__ + "static/media/ic_bonus_game_empty_slot_avatar.3fdf261bc6d2a5545d7d2347d9e401d5.svg";
export { ForwardRef as ReactComponent };